import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import GraficPizza from '../components/ElementsTeste/GraficoPizza';
import api from '../services/api';
import './Dashboard.css';

const Dashboard = () => {
  const [noentryforecast, setNoentryforecast] = useState([]);
  //const [longertenminutes, setLongertenminutes] = useState([]);
  const [visitsunit, setvisitsunit] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const visitas = 'Aguardando Agendamento'


        const [responseForecast, responseVisitStatus] = await Promise.all([
          //api.get('/api/front/visit/noentryforecast', {
          api.get(`/api/front/visits/get/${visitas}`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          api.get('/api/front/visit/bystatusunit', {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        setNoentryforecast(responseForecast.data.data.slice().reverse());
        setvisitsunit(responseVisitStatus.data.countsByUnit);
      } catch (error) {
        console.error('Erro ao buscar dados do dashboard:', error);
      }
    };

    fetchData(); // Chamada inicial

    const interval = setInterval(fetchData, 120000); // Atualiza a cada 2 minutos

    return () => clearInterval(interval); // Limpa o intervalo quando o componente desmontar
  }, []);

  const handleVerDetalhes = (item) => {
    // Redireciona para a página ConsultarVisitas/aguardando
    navigate('/ConsultarVisitas/aguardando');
  };

  return (

    <div className="container-dashboard">
      <CardSection title="Registros sem previsão de entrada" data={noentryforecast} onCardClick={handleVerDetalhes} />
      <div className='content-dashboard'>
        <GraficPizza
          title="DeHeus 01"
          data={[
            {
              label: 'Visitas Hoje',
              value: visitsunit?.["b2782350-0655-11f0-b6fa-9f7aebdea2ec"]?.total || 0,
              color: '#6A0DAD'
            },
            {
              label: 'Aguardando Agendamento',
              value: visitsunit?.["b2782350-0655-11f0-b6fa-9f7aebdea2ec"]?.aguardando_agendamento || 0,
              color: '#3E1F47'
            },
            {
              label: 'Aguardando Liberação',
              value: visitsunit?.["b2782350-0655-11f0-b6fa-9f7aebdea2ec"]?.aguardando_liberacao || 0,
              color: '#800020'
            },
            {
              label: 'Dentro da Unidade',
              value: visitsunit?.["b2782350-0655-11f0-b6fa-9f7aebdea2ec"]?.dentro_unidade || 0,
              color: '#BA55D3'
            },
            {
              label: 'Finalizadas',
              value: visitsunit?.["b2782350-0655-11f0-b6fa-9f7aebdea2ec"]?.finalizada || 0,
              color: '#4B0082'
            }
          ]}
        />

        <GraficPizza
          title="DeHeus 02"
          data={[
            {
              label: 'Visitas Hoje',
              value: visitsunit?.["813c4ab0-065e-11f0-a3b6-4dae11bd9299"]?.total || 0,
              color: '#6A0DAD'
            },
            {
              label: 'Aguardando Agendamento',
              value: visitsunit?.["813c4ab0-065e-11f0-a3b6-4dae11bd9299"]?.aguardando_agendamento || 0,
              color: '#3E1F47'
            },
            {
              label: 'Aguardando Liberação',
              value: visitsunit?.["813c4ab0-065e-11f0-a3b6-4dae11bd9299"]?.aguardando_liberacao || 0,
              color: '#800020'
            },
            {
              label: 'Dentro da Unidade',
              value: visitsunit?.["813c4ab0-065e-11f0-a3b6-4dae11bd9299"]?.dentro_unidade || 0,
              color: '#BA55D3'
            },
            {
              label: 'Finalizadas',
              value: visitsunit?.["813c4ab0-065e-11f0-a3b6-4dae11bd9299"]?.finalizada || 0,
              color: '#4B0082'
            }
          ]}
        />
      </div>
    </div>

  );
};

const CardSection = ({ title, data, onCardClick }) => (
  <>
    <h2>{title}</h2>
    <div className="content-dashboard">
      <div className="card-geral">
        {data.slice(0, 9).map((item) => (
          <div key={item.id} className="card" onClick={() => onCardClick(item)}>
            <div className="card-item">Operação: <strong>{item.operation}</strong></div>
            <div className="card-item">Número CG: <strong>{item.number_cg}</strong></div>
            <div className="card-item">Status: <strong>{item.visit_status}</strong></div>
          </div>
        ))}
      </div>
    </div>
  </>
);

export default Dashboard;